import React from 'react';
import { CTAButton } from './CTAButton';
import { modules } from '../data/modules';
export function ModulesSection() {
  return <section className="bg-ivory-deep px-4 sm:px-6 py-9 sm:py-12" data-id="element-106" data-mp="1ntwbsbwstd7s">
      <div className="max-w-4xl mx-auto" data-id="element-107" data-mp="1iv1pgzzmh6ix">
        <h2 className="font-heading font-extrabold uppercase text-lg sm:text-2xl leading-tight tracking-tight text-petrol text-center mb-6" data-id="element-108" data-mp="1ivurjnnmz7uq">
          The complete <span className="text-green-dark" data-id="element-109" data-mp="2bks5xfoq8ki7">6-module</span> system
        </h2>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-2.5 mb-6" data-id="element-110" data-mp="26l5sp68wf49e">
          {modules.map(module => <article key={module.number} className="bg-white border border-petrol/10 rounded-lg p-4 flex flex-col shadow-sm" data-id="element-111" data-mp="21ljil5oda44t">
              <p className="font-heading font-bold text-[9px] sm:text-[10px] uppercase tracking-[0.16em] text-green-dark mb-1.5" data-id="element-112" data-mp="1wp2m9o70kjgn">
                Module {module.number}
              </p>

              <h3 className="font-heading font-extrabold uppercase text-sm sm:text-base leading-tight tracking-tight text-petrol mb-1.5" data-id="element-113" data-mp="l6i07566eppt">
                {module.title}
              </h3>

              <p className="font-heading font-semibold text-[12px] sm:text-sm text-petrol/90 leading-snug mb-1.5" data-id="element-114" data-mp="1nttk9dk2vejf">
                {module.hook}
              </p>

              <p className="text-[12px] sm:text-sm text-petrol/70 leading-relaxed mb-3" data-id="element-115" data-mp="1dvcom3a72br1">
                {module.description}
              </p>

              <ul className="flex flex-wrap gap-1 mt-auto pt-2.5 border-t border-petrol/10" data-id="element-116" data-mp="103fvbvwshvt2">
                {module.tags.map(tag => <li key={tag} className="rounded bg-ivory border border-petrol/10 px-1.5 py-0.5 text-[9px] font-semibold uppercase tracking-wide text-petrol/65" data-id="element-117" data-mp="q736pcg3q856">
                    {tag}
                  </li>)}
              </ul>
            </article>)}
        </div>

        <div className="max-w-xs sm:max-w-sm mx-auto" data-id="element-118" data-mp="l6oudi7gwc1c">
          <CTAButton data-id="element-119" data-mp="2nuf3k1bt2i8f">Get all 6 modules now</CTAButton>
        </div>
      </div>
    </section>;
}